import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import StoryManagementModal from './StoryManagementModal';

/**
 * @author @muhammedburakak
 */
const StoryManagementList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, width: 50, show: false },
			{ Header: 'title', accessor: 'title', filterType: FilterType.string },
			{
				Header: 'expiryDate',
				accessor: 'expiryDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATE,
				showOnMobile: true
			},
			{
				Header: 'priority',
				accessor: 'priority',
				filterType: FilterType.number
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.string,
				showOnMobile: true
			}
		],
		[]
	);
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	return (
		<div>
			<PageHeader title="storyManagement">
				<Button icon={faPlus} label="add" onClick={() => NiceModal.show(StoryManagementModal)} />
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.STORY_MANAGEMENT}
				columns={columns}
				fetchUrl={ADMIN.STORY.GET_STORY_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
				defaultSort={defaultSort}
			/>
		</div>
	);
};

export default StoryManagementList;
